import createReducer from '../createReducer';

export const initialState = {
  isolineLayerOptions: {
    channel: 'r',
    densityForZoomLevels: [
        { zoom: 0, density: 4 },
        { zoom: 3, density: 5 },
        { zoom: 6, density: 6 },
    ],
    lineColor: [255, 255, 255, 128],
    onLoadBlurRadius: 10,
    renderBlurRadius: 4,
  },
  gradientColoringFragmentOptions: {
    decode: {
      channel: 'r',
      min: 80000,
      max: 120000,
    },
    stops: [
      { value: 900, color: [0, 255, 0] },
      { value: 1100, color: [255, 0, 0] },
    ],
    smooth: true,
    opacity: 0.5,
  },
};

export default createReducer({}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/charts/pressure.js